import React, { useState, useEffect } from 'react';
import { Modal, Form, Input, Button, Alert, message } from 'antd';
import { MailOutlined, UserOutlined } from '@ant-design/icons';
import { connect } from 'react-redux';
import { requestServerPost } from '../../actions';

const ActivateEmailModal = ({ visible, onCancel, onSuccess, userData, requestServerPost, usertoken }) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (visible && userData) {
            form.resetFields();
            setError(null);
        }
    }, [visible, userData, form]);

    const handleOk = async () => {
        try {
            const values = await form.validateFields();
            setLoading(true);
            setError(null);

            const params = new FormData();
            // userData.username corresponds to the guest username being activated
            params.append("username", userData.username);
            params.append("email", values.email);

            requestServerPost("verify_email", params, {}, (response) => {
                setLoading(false);
                // Check for success in response or response.data
                if (response?.status === "success" || response?.data?.status === "success" || (response?.data && response?.data?.status === "success")) {
                    // message.success("Email activation successful. A temporary password has been sent.");
                    Modal.success({
                        title: "Action Required",
                        content: (
                            <div>
                                <p>The email has been successfully bound to this account.</p>
                                <p><strong>Please verify your email by clicking the link sent to your email address.</strong></p>
                            </div>
                        ),
                        okText: "I Understand",
                        onOk: () => {
                            if (onSuccess) onSuccess();
                            onCancel();
                        }
                    });
                } else {
                    const msg = response?.message || response?.data?.message || "Activation failed";
                    setError(msg);
                }
            }, usertoken, {}, (err) => {
                setLoading(false);
                setError(err?.message || "An error occurred");
            });

        } catch (info) {
            console.log('Validate Failed:', info);
            setLoading(false);
        }
    };

    return (
        <Modal
            title="Activate Email / Bind Account"
            open={visible}
            onCancel={onCancel}
            maskClosable={false}
            footer={[
                <Button key="back" onClick={onCancel}>
                    Cancel
                </Button>,
                <Button key="submit" type="primary" loading={loading} onClick={handleOk}>
                    Activate
                </Button>,
            ]}
        >
            <div style={{ marginBottom: 16 }}>
                <Alert
                    message="Bind Email Address"
                    description={`Bind an email address to user '${userData?.username || ''}' to enable permanent access.`}
                    type="info"
                    showIcon
                />
            </div>

            <Form
                form={form}
                layout="vertical"
                name="activate_email_form"
            >
                <Form.Item
                    label="Current Username"
                >
                    <Input prefix={<UserOutlined />} value={userData?.username} disabled />
                </Form.Item>

                <Form.Item
                    name="email"
                    label="New Email Address"
                    rules={[
                        { required: true, message: 'Please input the email!' },
                        { type: 'email', message: 'The input is not valid E-mail!' },
                    ]}
                >
                    <Input prefix={<MailOutlined />} placeholder="user@example.com" />
                </Form.Item>
            </Form>
            {error && <Alert message={error} type="error" showIcon style={{ marginTop: 10 }} />}
        </Modal>
    );
};

const mapStateToProps = (state) => ({
    usertoken: state.usertoken
});

export default connect(mapStateToProps, { requestServerPost })(ActivateEmailModal);
